import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';
import storage from "./storage";

const superagent = superagentPromise(_superagent, global.Promise);

const encode = encodeURIComponent;

const getAppParams = () => {
    const userInfo = storage.MpUserInfo.get();
    const params = {
        libraryId: 0,
    };
    if (userInfo) {
        params.tk = userInfo.token || '';
    }
    return params;
};

class MyError extends Error {
    code = 0;

    constructor(code, message) {
        super();
        this.msg = message;
        this.code = code;
    }
}

const tokenPlugin = req => {
    // const tk = getCachedToken();
    // if (tk) {
    //     req.set('authorization', `Token ${tk}`);
    // }
};

const handleErrors = err => {
    if (err && err.response && err.response.status === 401) {
    }
    return err;
};

const responseBody = (res) => {
    const body = res.body;
    if (body.code === 0) {
        return body.data;
    }
    throw new MyError(body.code, body.message);
};

const requests = {
    del: (url, body, params) =>
        superagent
            .del(`${url}`, body)
            .query({...params, ...getAppParams()})
            .use(tokenPlugin)
            .end(handleErrors)
            .then(responseBody),
    get: (url, params) =>
        superagent
            .get(`${url}`)
            .query({...getAppParams(), ...params})
            .use(tokenPlugin)
            .end(handleErrors)
            .then(responseBody),
    put: (url, body) =>
        superagent
            .put(`${url}`, body)
            .query({...getAppParams()})
            .use(tokenPlugin)
            .end(handleErrors)
            .then(responseBody),
    post: (url, body, params) =>
        superagent
            .post(`${url}`, body)
            .query({...getAppParams(), ...params})
            .use(tokenPlugin)
            .end(handleErrors)
            .then(responseBody),
};

const limit = (count, p) => `limit=${count}&offset=${p ? p * count : 0}`;


let dev = process.env.NODE_ENV !== 'production';
dev = false;
let host = 'https://api.flyfrog.sailorlab.com/brand';
if (dev) {
    host = 'http://localhost:8080/brand';
}

const Captcha = {
    send: (mobile) => {
        return requests.post(`${host}/sale/purchase/captcha`, {
            mobile
        });
    },
    validate: (mobile, captcha) => {
        return requests.post(`${host}/sale/purchase/captcha/validate`, {
            mobile, captcha
        });
    }
};

const Channel = {
    sendCaptcha: mobile => {
        return requests.post(`${host}/sale/channel/captcha`, {
            mobile
        });
    },
    getQrcode: id => {
        return requests.get(`${host}/sale/channel/${id}/qrcode`, {});
    },
    findById: (id, params) => {
        return requests.get(`${host}/sale/channel/${id}`, params);
    },
    findByCode: (code, params) => {
        return requests.get(`${host}/sale/channel/code/${code}`, params);
    },
    login: (mobile, captcha) => {
        return requests.post(`${host}/sale/channel/login`, {
            mobile, captcha
        });
    }
};

const Wechat = {
    getConfig: () => {
        return requests.get(`${host}/wechat/mp/config`);
    },
    getAuthorizationUrl: () => {
        return requests.get(`${host}/wechat/mp/auth_url`);
    },
    login: (code, fromId) => {
        return requests.get(`${host}/wechat/mp/login?${fromId ? `fromId=${fromId}` : ''}`, {
            code
        });
    }
};

const ChannelUser = {
    add: (params) => {
        const userInfo = storage.MpUserInfo.get();
        return requests.post(`${host}/sale/${userInfo.id}/channel_user`, params);
    },
    findByUser: (id, params) => {
        console.log(params);
        return requests.get(`${host}/sale/channel_user/${id}`, params);
    },
    getListByChannel: (channelId, params) => {
        return requests.get(`${host}/sale/channel/${channelId}/user/list`, params);
    }
};

const ChannelOrder = {
    add: (params) => {
        return requests.post(`${host}/sale/channel_order`, params);
    },
    findByOrderId: (orderId, params) => {
        return requests.get(`${host}/sale/channel_order/${orderId}`, params);
    }
};

const SaleProduct = {
    getList: () => {
        return requests.get(`${host}/sale/product/list`, {});
    }
};

const Library = {
    findById: (id) => {
        return requests.get(`${host}/library/${id}`, {});
    }
};

const Shop = {
    findAll: (params) => {
        return requests.get(`${host}/shop/list`, params);
    },
    findById: (id, params) => {
        return requests.get(`${host}/shop/${id}`, params);
    }
};

export default {
    Shop
};
